import { MfeSourceType } from '../models/index';

export const MfeElementType = {
  [MfeSourceType.js]: 'script',
  [MfeSourceType.css]: 'link'
};
